import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 번역 파일들
import koTranslations from "./locales/ko.json";
import enTranslations from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: {
        translation: koTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    fallbackLng: "ko", // 기본 언어
    debug: false, // 개발 시에만 true로 설정

    interpolation: {
      escapeValue: false, // React는 이미 XSS 보호가 되어 있음
    },

    detection: {
      // 언어 감지 우선순위
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
